<template>
		<div class="page_mulu page_shadow">
			<h5 class="header">
				<span>目录</span>
			</h5>
			<div class="content">
				<div class="content_box" v-for="(item, index) in list">
					<div class="big_title_box">
						<div class="big_title"><span>Part{{index + 1}}</span>{{item.title}}</div>
						<div class="line"></div>
						<div class="page_number"></div>
					</div>
					<template v-for="(child,idx) in item.sTitle">
						<div class="small_title_box">
							<div class="small_titled">{{index + 1}}{{child.s_title}}</div>
							<div class="line"></div>
							<div class="page_number"></div>
						</div>
						<div class="g_small_title_box" v-for="(g_child,idx) in child.gTitle">
							<div class="small_titled">{{index + 1}}{{g_child.g_title}}</div>
							<div class="line"></div>
							<div class="page_number"></div>
						</div>
					</template>
				</div>
			</div>
		</div>
</template>
<script>
export default {
	components: {  },
    props: ['list'],
    data() {
        return {

        }
    },
    methods: {

    },
    watch: {

    },
    created() {
    	
    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_mulu {
		.content {

			.content_box {
				margin-bottom: 30px;
			}
		}
		.big_title_box {
			display: flex;
			line-height: 50px;
			color: #333;
			font-weight: bold;
			.big_title {
				position: relative;
				padding-left: 70px;
				padding-right: 20px;
				font-size: 20px;
				span {
					height: 50px;
					font-size: 24px;
					line-height: 50px;
					text-align: center;
					width: 30px;
					position: absolute;
					left: 0px;
					top:  0px;
				}	
			}
			.line {
				flex: 1;
				border-top: 2px dotted #333;
				margin: auto 0;
			}
			.page_number {
				padding-left: 10px;
				font-size: 18px;
			}
		}
		.small_title_box {
			.big_title_box;
			font-weight: normal;
			color: #8A8A8A;
			line-height: 40px;
			.small_titled {
				padding-left: 30px;
				padding-right: 20px;
			}
			.line {
				border-top: 2px dotted #8A8A8A;
			}
			.page_number {
				font-size: 16px;
			}
		}
		.g_small_title_box {
			.big_title_box;
			font-weight: normal;
			color: #8A8A8A;
			line-height: 40px;
			.small_titled {
				padding-left: 60px;
				padding-right: 20px;
				font-size: 14px;
			}
			.line {
				border-top: 2px dotted #8A8A8A;
			}
			.page_number {
				font-size: 14px;
			}
		}
	}
</style>